import React from "react";
import { Card, Col, Row, Button, FormGroup, Label, Input } from "reactstrap";
import Select from "react-select";
import makeAnimated from "react-select/lib/animated";
import forOwn from "mout/object/forOwn";
import getBaseQuery from "../../../helpers/assessment/getBaseQuery";
export default function FilterByNode({
  newReport,
  query,
  navTo,
  nodes,
  selectedOption
}) {
  const options = [];
  
  forOwn(newReport, (val, key) => {
    if (key === "report") {
      forOwn(val, (v, k) => {
        forOwn(v, (va, ke) => {
          options.push({
            value: va.id,
            label: va.name
          });
        });
      });
    }
  });
 
  const spanColor = {
    backgroundColor: "#00C1AB",
    borderColor: "#00C1AB",
    width:"100%",
    borderRadius: "10px 0 0 10px" ,
    minHeight:"38px"
  }
  options.sort(function(a, b) {
    if (a.label > b.label) return 1;
    if (a.label < b.label) return -1;
  });

  function getNdQuery(query, nodeId) {
    const baseQuery = getBaseQuery(query, "nd");
    let endQuery = `&nd=${nodeId}`;

    return `${baseQuery}${endQuery}`;
  }
  function getQuery(query, nodeId) {
    const baseQuery = getBaseQuery(query, "nd");
    // let endQuery = `&nd=${nodeId}`

    return `${baseQuery}`;
  }

  function handleChange(e) {
    let ndQuery = "";
    if (e !== null) {
      ndQuery = getNdQuery(query, e.value);
    } else {
      ndQuery = getQuery(query);
    }
   
    navTo(ndQuery);
  }
  return (
    <Row className="mb-3">
      <Col xs="4" sm="5" lg="3" xl="2" className="item-report-skills pr-0">
        <span className="btn btn-primary" style={spanColor}>
          Filter By 
        </span>{" "}
        
      </Col>
      <Col xs="8" sm="7" lg="9" xl="10" className="pl-0" >
        <Select
          closeMenuOnSelect={true}
          components={makeAnimated()}
          isClearable={true}
          options={options}
          defaultValue={selectedOption}
          value={selectedOption}
          onChange={e => handleChange(e)}
        />
      </Col>
    </Row>
  );
}



// WEBPACK FOOTER //
// ./src/components/Assessment/AssessOverviewFilter/FilterByNode.js